// 결제 종류별 금액 설정 파일
// NOTE: 백엔드에도 동일한 파일이 있으며, 금액이 같아야지만 허용되게 예외처리가 적용되어 있음
// NOTE: Tosspayments 구조상, 판매 가격을 프론트엔드에서 정해야 함이 그 이유

export const examAmount = 25000
export const eventAmount = 110000
export const premiumAmount = 10000